<agr-powerbi-report [workspaceId]="workspaceId" [reportId]="reportId" />
